module.exports = __webpack_public_path__ + "static/media/no.924b8169.png";